var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{directives:[{name:"show",rawName:"v-show",value:(_vm.playing),expression:"playing"}],attrs:{"id":_vm.unique_id,"opacity":"0","fill":"none","stroke":"#FFFFFF","stroke-width":"100"}})
}
var staticRenderFns = []

export { render, staticRenderFns }